
export const ICONS = {
    noPicture: require("../assets/images/base/nopicture.webp"),
    logo: require("../assets/images/base/WyensLogo.webp"),
}